import templateUrl from "emun.order/order-container.htm";
import listTemplateUrl from "emun.order/order-list.htm";
import controller from "emun.order/order-container.controller";

const isList = (type = "") => type === "list" || type === "mutli-view";

export default {
  bindings: {
    customer: "<",
    salesrep: "<",
    vendor: "<",
    uploaded: "<",
    toUpload: "<",
    mode: "@",
    hideHeader: "@",
    detailRoute: "@",
    disableQueryString: "<?",
    repGroup: "@",
    writingRepId: "@",
    useErpStatus: "=",
    managerId: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return (
      $attrs.templateUrl ||
      (isList($attrs.type) ? listTemplateUrl : templateUrl)
    );
  },
};
